export default __webpack_public_path__ + "static/media/ic_government.df5fb223.svg";